import { invokeHttp } from './api'

export const list = (filter) =>
  invokeHttp('/admin/caregiver/list', filter)

export const get = (id) =>
  invokeHttp('/admin/caregiver/get', { id })

export const gethistory = (id) =>
  invokeHttp('/admin/caregiver/gethistory', { id })

export const create = (caregiver) =>
  invokeHttp('/admin/caregiver/create', caregiver)

export const update = (caregiver) =>
  invokeHttp('/admin/caregiver/update', caregiver)

export const uploadPhoto = (data, onProgress) =>
  invokeHttp('/admin/caregiver/uploadphoto', data, {
    onUploadProgress (progressEvent) {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
      if (onProgress) {
        onProgress(percentCompleted)
      }
      return percentCompleted
    },
  })

export const calendar = (id) =>
  invokeHttp('/admin/caregiver/calendar', { id })

export const behaviorDashboard = (caregiverId) =>
  invokeHttp('/admin/caregiver/behavior/dashboard', { caregiverId })

export const behaviorRating = (caregiverId) =>
  invokeHttp('/admin/caregiver/behavior/rating', { caregiverId })

export const behaviorCommentCreate = (caregiverId, behaviorType, patientId, changeRating, comment) =>
  invokeHttp('/admin/caregiver/behavior/comment/create', {
    caregiverId,
    behaviorType,
    patientId,
    changeRating,
    comment,
  })

export const behaviorCommentUpdate = (id, patientId, comment) =>
  invokeHttp('/admin/caregiver/behavior/comment/update', {
    id,
    patientId,
    comment,
  })

export const behaviorPatientSearch = (keywords) =>
  invokeHttp('/admin/caregiver/behavior/patient-search', { keywords })

export const behaviorCommentList = (caregiverId, behaviorType, asc, limit, page) =>
  invokeHttp('/admin/caregiver/behavior/comment/list', { caregiverId, behaviorType, asc, limit, page })

export const behaviorCommentRemove = (id, caregiverId) =>
  invokeHttp('/admin/caregiver/behavior/comment/delete', { id, caregiverId })
